import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-kmEIp7ud.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--ar-AE" */'./ar-AE-CqQy6508.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--de-DE" */'./de-DE-Ch8iMojn.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-AU" */'./en-AU-y50_ikYl.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-CA" */'./en-CA-DeGdLHVt.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-GB" */'./en-GB-M6VhBofv.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-IN" */'./en-IN-CmtPY4YK.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--en-SG" */'./en-SG-BWTbvH9-.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--es-CO" */'./es-CO-BigJn1fC.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--es-ES" */'./es-ES-CfkF9I-K.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--es-MX" */'./es-MX-CLVOyt-l.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--fr-CA" */'./fr-CA-DvJTdIHb.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--fr-FR" */'./fr-FR-C4fHQqrA.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--hi-IN" */'./hi-IN-B_QFtGVo.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--it-IT" */'./it-IT-C0-RhYvK.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--ja-JP" */'./ja-JP-Dhige5QP.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--ko-KR" */'./ko-KR-D8NuZyLM.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--nl-NL" */'./nl-NL-DKTg1S83.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--pl-PL" */'./pl-PL-DlEo-zMU.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--pt-BR" */'./pt-BR-DqNAJt_M.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--sv-SE" */'./sv-SE-BIPAgVKz.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--ta-IN" */'./ta-IN-TswbcgLR.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--th-TH" */'./th-TH-8qYrBDwr.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--tr-TR" */'./tr-TR-DYTNq8aD.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--vi-VN" */'./vi-VN-17maQHb2.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--zh-CN" */'./zh-CN-C4f4ScXE.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui-country-selector--CountrySelector--zh-TW" */'./zh-TW-DWLa4V51.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-BlfEeMie.js.map
